<div class="flex min-h-screen w-full flex-col">
    <recover-header></recover-header>
    <div
        class="absolute inset-0 flex min-w-0 flex-col overflow-y-auto pt-40"
        cdkScrollable
    >
        <router-outlet></router-outlet>
        <recover-footer></recover-footer>
    </div>
</div>
